import * as React from "react";

const BrandLogo = () => {
  return (
    <div className="brandLogo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="234"
        height="38"
        viewBox="0 0 234 38"
        fill="none"
      >
        <g clipPath="url(#clip0_2_506)">
          <path
            d="M34.5751 4.99219V34.1172H24.6434V22.7183H9.97445V34.1172H0V4.99219H9.97445V15.6427H24.6434V4.99219H34.5751Z"
            fill="#DF6919"
          />
          <path
            d="M65.4208 25.0883H46.1001C46.6455 27.376 48.2388 29.2073 51.9255 29.2073C54.8181 29.2073 56.2002 27.7502 56.9541 26.6276H65.0839C63.659 32.7026 58.0021 34.7409 51.9255 34.7409C44.7581 34.7409 37.5078 31.6198 37.5078 23.05C37.5078 14.4802 44.8008 11.3591 51.7143 11.3591C58.0422 11.3591 66.0464 14.7695 65.4181 25.0883H65.4208ZM56.8712 20.4703C56.2002 18.1826 54.524 16.8927 51.7169 16.8927C48.5329 16.8927 46.8968 18.432 46.2685 20.4703H56.8712Z"
            fill="#DF6919"
          />
          <path
            d="M67.9765 11.9403H77.1115V34.1171H67.9765V11.9403Z"
            fill="#DF6919"
          />
          <path
            d="M121.535 19.8466V34.1172H112.4V21.9274C112.4 19.4724 112.149 17.5589 109.091 17.5589C106.032 17.5589 105.57 19.43 105.57 21.9274V34.1172H96.4349V21.9274C96.4349 19.4724 96.1408 17.5589 93.0824 17.5589C90.0241 17.5589 89.6043 19.43 89.6043 21.9274V34.1172H80.4693V11.9404H89.6043V14.6448C90.3582 13.4797 92.497 11.3591 96.6461 11.3591C100.501 11.3591 103.017 12.442 104.356 14.6448C105.53 13.3549 108.086 11.3591 112.235 11.3591C118.394 11.3591 121.538 14.1883 121.538 19.8466H121.535Z"
            fill="#DF6919"
          />
          <path
            d="M144.251 25.0458H152.718C151.587 32.1187 144.965 34.7409 138.637 34.7409C131.764 34.7409 124.054 31.6198 124.054 23.05C124.054 14.4802 131.764 11.3591 138.637 11.3591C144.965 11.3591 151.587 13.9813 152.718 21.0117H144.251C143.666 18.8912 141.904 17.2669 138.634 17.2669C134.403 17.2669 132.809 20.0536 132.809 23.05C132.809 26.0464 134.403 28.8331 138.634 28.8331C141.904 28.8331 143.663 27.169 144.251 25.0458Z"
            fill="#364F8E"
          />
          <path
            d="M204.798 11.7333V19.3875H204.045C202.914 18.931 201.403 18.3896 199.393 18.3896C194.698 18.3896 193.399 21.2187 193.399 24.6716V34.1172H184.264V11.9403H193.399V15.3507C194.239 13.8937 196.709 11.3564 201.572 11.3564C202.997 11.3564 204.045 11.4812 204.798 11.7307V11.7333Z"
            fill="#364F8E"
          />
          <path
            d="M233.965 25.0883H214.645C215.19 27.376 216.783 29.2073 220.47 29.2073C223.363 29.2073 224.745 27.7502 225.499 26.6276H233.628C232.203 32.7026 226.547 34.7409 220.47 34.7409C213.303 34.7409 206.052 31.6198 206.052 23.05C206.052 14.4802 213.345 11.3591 220.259 11.3591C226.587 11.3591 234.591 14.7695 233.963 25.0883H233.965ZM225.416 20.4703C224.745 18.1826 223.068 16.8927 220.261 16.8927C217.077 16.8927 215.441 18.432 214.813 20.4703H225.416Z"
            fill="#364F8E"
          />
          <path
            d="M72.4839 9.03953C74.9983 9.03953 77.0367 7.01596 77.0367 4.51977C77.0367 2.02357 74.9983 0 72.4839 0C69.9694 0 67.9311 2.02357 67.9311 4.51977C67.9311 7.01596 69.9694 9.03953 72.4839 9.03953Z"
            fill="#DF6919"
          />
          <path
            d="M168.646 27.108C172.321 27.108 175.3 24.1505 175.3 20.5022C175.3 16.8539 172.321 13.8964 168.646 13.8964C164.971 13.8964 161.992 16.8539 161.992 20.5022C161.992 24.1505 164.971 27.108 168.646 27.108Z"
            fill="#364F8E"
          />
          <path
            d="M189.199 11.9404H181.117C180.708 11.9404 180.465 12.3889 180.687 12.7286C182.529 15.5206 183.411 18.9921 182.871 22.6838C181.968 28.8358 177.091 33.7112 170.9 34.6454C166.489 35.3115 162.382 33.9845 159.353 31.434C159.228 31.3279 159.038 31.3358 158.92 31.4526C158.8 31.5721 158.792 31.7631 158.907 31.8879C163.088 36.551 169.646 39.0696 176.696 37.5648C183.505 36.1104 188.897 30.8687 190.469 24.1302C191.496 19.7299 190.916 15.5127 189.197 11.9377L189.199 11.9404Z"
            fill="#DF6919"
          />
        </g>
        <defs>
          <clipPath id="clip0_2_506">
            <rect width="234" height="38" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default BrandLogo;
